import React from 'react';
import { Eye, HelpCircle, Target, Shield, Sparkles, ArrowRight } from 'lucide-react';

export const PerceptionTestSection = () => {
  const questions = [
    "Que vend cette entreprise ?",
    "Est-ce destiné à quelqu'un comme moi ?",
    "Pourquoi devrais-je m'y intéresser ?",
    "Puis-je lui faire confiance ?",
    "Quelle est sa différence ?",
    "Quelle action dois-je entreprendre ensuite ?"
  ];

  return (
    <section className="py-32 bg-white relative">
      <div className="container-custom">
        <div className="max-w-4xl mx-auto fade-in-section">
          <h2 className="section-title mb-12 text-center">
            Ce qu'un prospect comprend<br />
            en <span className="text-accent">30 secondes</span>
          </h2>

          <div className="prose prose-lg max-w-none space-y-6 mb-12">
            <p className="text-gray-700 leading-relaxed">
              Lorsqu'un prospect découvre une entreprise, il ne connaît ni son histoire, ni ses efforts, ni tout ce qui se cache derrière son offre.
            </p>
            <p className="text-gray-700 leading-relaxed">
              En quelques secondes, il cherche instinctivement à comprendre :
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-4 mb-12">
            {questions.map((question, index) => (
              <div 
                key={index}
                className="flex items-center gap-3 p-4 bg-gray-50 rounded-lg"
              >
                <ArrowRight className="h-5 w-5 text-accent flex-shrink-0" />
                <p className="text-gray-800 font-medium">{question}</p>
              </div>
            ))}
          </div>

          <p className="text-gray-700 leading-relaxed mb-12 text-center">
            Si les réponses sont floues, contradictoires ou trop longues à trouver, la valeur réelle de l'entreprise est partiellement perdue avant même le premier échange.
          </p>

          <div className="p-8 bg-gradient-to-br from-gray-900 to-gray-800 rounded-lg text-center">
            <Eye className="h-12 w-12 mx-auto mb-4" style={{ color: '#EFF581' }} />
            <p className="text-xl text-white font-medium leading-relaxed">
              Le prospect ne juge pas uniquement qui vous êtes.<br />
              Il décide à partir de ce qu'il parvient à <span style={{ color: '#EFF581' }}>percevoir</span>.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PerceptionTestSection;
